import image1 from "../../assets/images/Home/home_collection_grid_4.jpg";
import image2 from "../../assets/images/Home/home_collection_grid_5.jpg";
import image3 from "../../assets/images/Home/home_collection_grid_6.jpg";
import { Link } from "react-router-dom";
import React from "react";

const shop_blocks = [
  {
    id: "4",
    image: image1,
    title: "TIMELESS ELEGANCE",
    link: "/",
  },
  {
    id: "5",
    image: image2,
    title: "TIMELESS ELEGANCE",
    link: "/",
  },
  {
    id: "6",
    image: image3,
    title: "TIMELESS ELEGANCE",
    link: "/",
  },
];

const CollectionGridShop = () => {
  return (
    <div className="home_collection_grid collection_grid">
      {shop_blocks.map((block) => (
        <Link
          to={block.link}
          className={`grid_block grid_block_${block.id}`}
          key={block.id}
        >
          <img src={block.image} alt={block.title} />
          <div className="text_con">
            <p>{block.title}</p>
            <span>EXPLORE+</span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default CollectionGridShop;
